import React, { useCallback } from "react"
import { Box, Typography } from "@material-ui/core";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import { useProductFormStyles } from "./ProductForm.style";
import { FormControl, RadioGroup, Radio } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { ApprovalType } from "./ProductForm.type";
import { updateFormField } from "../../../../../store/actions/productFormActions";
import { RootState } from "../../../../../store/types";

interface ApprovalFlowOption {
  value: ApprovalType;
  label: string;
  description: string;
}

export const SubscriptionApprovalType: React.FC = () => {
  const classes = useProductFormStyles();
  const dispatch = useDispatch();

  // Get approval flow and visibility from Redux
  const { approvalFlow, visibility, product, isEditing } = useSelector((state: RootState) => state.productForm);
  const isPublicDraft = visibility?.value === 'public';
  const isPublicPersisted =
    isEditing && (product?.visibility ?? '').toLowerCase() === 'public';

  // Define approval flow options array
  const approvalFlowOptions: ApprovalFlowOption[] = [
    {
      value: 'open',
      label: 'Open',
      description: 'Immediate access with auto-approved requests.',
    },
    {
      value: 'closed',
      label: 'Closed',
      description: 'Manual approval required.',
    }
  ];

  // Handle approval flow change
  const handleApprovalFlowChange = useCallback((e) => {
    const value = e.target.value as ApprovalType;
    dispatch(updateFormField('approvalFlow', value, true, null));
  }, [dispatch]);
  return (
    <>
      <Box>
        <Typography className={classes.sectionTitle}>
          Subscription Approval
        </Typography>
        {(isPublicDraft || isPublicPersisted) && (
          <Box className={classes.subscriptionPublicNotice}>
            <InfoOutlined fontSize="inherit" />
            <Typography variant="body2" component="span">
              Public products require immediate access.
            </Typography>
          </Box>
        )}
        <FormControl
          component="fieldset"
          disabled={isPublicPersisted}
          className={isPublicPersisted ? classes.visibilityRadiosPublicLocked : undefined}
        >
          <RadioGroup
            value={approvalFlow.value}
            onChange={handleApprovalFlowChange}
            className={classes.radioGroup}
          >
            {approvalFlowOptions.map((option) => (
              <Box key={option.value} className={classes.radioOption}>
                <Box className={classes.radioContent}>
                  <Radio
                    value={option.value}
                    color="primary"
                    className={classes.radioControl}
                    disabled={isPublicPersisted}
                  />
                  <Box className={classes.radioText}>
                    <Typography className={classes.radioLabel}>
                      {option.label}
                    </Typography>
                    <Typography className={classes.radioDescription}>
                      {option.description}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
    </>
  )
}